export enum DifferenceType {
  DELETED = 'DELETED',
  OBJECT_DETAILS_UPDATED = 'OBJECT_DETAILS_UPDATED',
  PROPERTIES_UPDATED = 'PROPERTIES_UPDATED',
  STOCKING_POINTS_UPDATED = 'STOCKING_POINTS_UPDATED',
  TURBINE_DETAILS = 'TURBINE_DETAILS',
  NEW = 'NEW'
}
